import React, { useEffect, useState } from 'react'
import { Stack } from 'react-bootstrap'
import { SelectDropdown, SelectOption } from '../../../../../components/SelectDropdown/SelectDropdown'

export interface ContactFilterProps {
  contactFilterValues: SelectOption[]
  selectedContactId: string | null
  disabled?: boolean
  onSelectedChanged: (id: string) => void
  onSearchInputChange: (searchInput: string) => Promise<void>
}

export const ContactFilter: React.FC<ContactFilterProps> = ({ contactFilterValues, selectedContactId, disabled, onSelectedChanged, onSearchInputChange }) => {
  const [selectedOption, setSelectedOption] = useState<SelectOption | null>(null)

  const handleOptionSelected = (option: SelectOption) => {
    setSelectedOption(option)
    onSelectedChanged(option.id)
  }

  useEffect(() => {
    const option = contactFilterValues.find(({ id }) => id === selectedContactId)
    if (option) {
      setSelectedOption(option)
    }
  }, [contactFilterValues, selectedContactId])

  return (
    <Stack>
      <div className='d-flex mb-1'>
        <div className='text-nowrap'>Filter by contact</div>
      </div>

      <SelectDropdown
        options={contactFilterValues}
        initialSelectedOption={selectedOption}
        onOptionSelected={handleOptionSelected}
        placeholder='Select Contact'
        searchable
        disabled={disabled}
        onSearchInputChange={onSearchInputChange}
      />
    </Stack>
  )
}
